import PreviewConsumerPagePanel from "./previewConsumerPagePanel.container";

export default PreviewConsumerPagePanel;
